const ISLIVE = process.env.REACT_APP_IS_LIVE === '1'

export const BaseUrls: any = {
	API_SERVER: {
		url: ISLIVE ? process.env.REACT_APP_API_BASE_URL_LIVE : process.env.REACT_APP_API_BASE_URL_UAT
	},
	THIRD_PARTY_API_SERVER: {
		url: ISLIVE ? process.env.REACT_APP_KHEETIGADI_API_BASE_URL : process.env.REACT_APP_KHEETIGADI_API_BASE_URL
	},
}
